export default __webpack_public_path__ + "assets/models/fd427e0835cd0a0538a1b09757c112d6.glb";